import IInputMaskItem, { MaskValue } from './IInputMaskItem';

export default class InputMaskSeparator extends IInputMaskItem {
    private _mask: string = '';
    private shouldBeIncludedInOutput: boolean;

    public get mask(): string {
        return this._mask;
    }

    public set mask(val: string) {
        this._mask = val;
        this.maskValue = Array.from(val, (_, i) => new MaskValue(val[i]));
    }

    constructor(mask: string, shouldBeIncludedInOutput: boolean = true) {
        super();
        this.mask = mask;
        this.shouldBeIncludedInOutput = shouldBeIncludedInOutput;
    }

    addUserInput(char: string, charIndex: number): boolean {
        // Any input here will skip over the whole separator, so fill the whole separator
        this.maskValue.forEach((mv) => (mv.userValue = mv.placeHolder));

        return true;
    }

    removeUserInput(charIndex: number): boolean {
        if (this.maskValue[charIndex].userValue == null) {
            return false;
        }

        this.maskValue[charIndex].userValue = null;
        return true;
    }

    getCurrentDisplayValue(): string {
        if (!this.shouldBeIncludedInOutput) {
            return '';
        }
        return this.maskValue.reduce((res, mv) => res + (mv.userValue || mv.placeHolder), '');
    }

    /**
     * This will return an empty string as the separator until the mask is filled
     * @param isMaskFilled
     * @returns
     */
    getCurrentTextForInputElement(isMaskFilled?: boolean): string {
        return this.maskValue.reduce((res, mv) => res + (isMaskFilled ? mv.placeHolder : ' '.repeat(mv.placeHolder.length)), '');
    }

    public getGrayMaskValue(): string {
        return this.maskValue.reduce((res, mv) => res + (mv.userValue || mv.placeHolder), '');
    }

    isMaskFilled(): boolean {
        return true; // Separator is always filled
    }
}
